import { Helmet } from "react-helmet-async";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Breadcrumbs from "@/components/Breadcrumbs";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Check, Star, BadgePercent, Wallet, TrendingDown, Sparkles, Play, ArrowRight } from "lucide-react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { useAffiliateTracking } from "@/hooks/useAffiliateTracking";

const IptvPasCher = () => {
  useAffiliateTracking();
  const faqData = [
    {
      question: "Comment trouver un IPTV pas cher et fiable ?",
      answer: "Le meilleur rapport qualité/prix combine un service stable, une bonne qualité d'image et un support réactif. RoiDuStreaming propose des abonnements dès 5€/mois avec une qualité 4K et un support 7j/7, ce qui en fait l'un des meilleurs choix du marché."
    },
    {
      question: "Pourquoi l'IPTV est-il moins cher que les abonnements classiques ?",
      answer: "L'IPTV utilise la technologie internet pour diffuser le contenu, réduisant les coûts d'infrastructure. Un seul abonnement IPTV remplace Netflix, Canal+, beIN Sports et Disney+ pour une fraction du prix total de ces services séparés."
    },
    {
      question: "L'IPTV pas cher est-il de bonne qualité ?",
      answer: "Chez RoiDuStreaming, nous proposons une qualité premium malgré nos prix bas. Nos serveurs haute performance garantissent une diffusion en 4K HDR sans buffering, même pendant les événements sportifs populaires."
    },
    {
      question: "Combien coûte un abonnement IPTV par mois ?",
      answer: "Nos abonnements vont de 5€/mois (abonnement 12 mois à 60€) à 8,33€/mois (abonnement 3 mois à 25€). C'est jusqu'à 90% moins cher que les abonnements streaming traditionnels combinés."
    },
    {
      question: "Y a-t-il des frais cachés ?",
      answer: "Aucun frais caché ! Le prix affiché est le prix final. Pas de reconduction automatique, pas de supplément pour la qualité 4K ou le sport. Tout est inclus dans votre abonnement."
    },
    {
      question: "Puis-je tester avant de payer ?",
      answer: "Oui ! Nous offrons un test gratuit de 24 heures pour découvrir l'intégralité du service. Aucune carte bancaire n'est requise pour le test, et vous n'êtes pas engagé à acheter ensuite."
    },
    {
      question: "Comment économiser le maximum sur l'IPTV ?",
      answer: "Optez pour l'abonnement annuel à 60€ (soit 5€/mois). Vous économisez 40% par rapport à l'offre 3 mois et bénéficiez d'un an complet de streaming illimité."
    },
    {
      question: "L'IPTV pas cher inclut-il le sport en direct ?",
      answer: "Oui, tous nos abonnements incluent l'accès complet au sport : Ligue 1, Champions League, Premier League, UFC, F1, tennis... Pas de supplément pour les événements premium."
    }
  ];

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Product",
    "name": "IPTV Pas Cher - Abonnement Streaming Économique",
    "description": "IPTV pas cher dès 5€/mois. Accès à +15 000 chaînes, +100 000 films, +25 000 séries, sport 4K. Économisez jusqu'à 90% vs abonnements classiques.",
    "brand": { "@type": "Brand", "name": "RoiDuStreaming" },
    "offers": {
      "@type": "AggregateOffer",
      "offerCount": 3,
      "lowPrice": "5",
      "highPrice": "8.33",
      "priceCurrency": "EUR",
      "offers": [
        { "@type": "Offer", "name": "3 Mois", "price": "25", "priceCurrency": "EUR", "availability": "https://schema.org/InStock", "priceValidUntil": "2026-12-31", "url": "https://roidustreaming.fr/iptv-pas-cher",
          "hasMerchantReturnPolicy": { "@type": "MerchantReturnPolicy", "applicableCountry": "FR", "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow", "merchantReturnDays": 14, "returnMethod": "https://schema.org/ReturnByMail", "returnFees": "https://schema.org/FreeReturn" },
          "shippingDetails": { "@type": "OfferShippingDetails", "shippingRate": { "@type": "MonetaryAmount", "value": "0", "currency": "EUR" }, "shippingDestination": { "@type": "DefinedRegion", "addressCountry": "FR" }, "deliveryTime": { "@type": "ShippingDeliveryTime", "handlingTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 0, "unitCode": "h" }, "transitTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 1, "unitCode": "h" } } }
        },
        { "@type": "Offer", "name": "6 Mois", "price": "40", "priceCurrency": "EUR", "availability": "https://schema.org/InStock", "priceValidUntil": "2026-12-31", "url": "https://roidustreaming.fr/iptv-pas-cher",
          "hasMerchantReturnPolicy": { "@type": "MerchantReturnPolicy", "applicableCountry": "FR", "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow", "merchantReturnDays": 14, "returnMethod": "https://schema.org/ReturnByMail", "returnFees": "https://schema.org/FreeReturn" },
          "shippingDetails": { "@type": "OfferShippingDetails", "shippingRate": { "@type": "MonetaryAmount", "value": "0", "currency": "EUR" }, "shippingDestination": { "@type": "DefinedRegion", "addressCountry": "FR" }, "deliveryTime": { "@type": "ShippingDeliveryTime", "handlingTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 0, "unitCode": "h" }, "transitTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 1, "unitCode": "h" } } }
        },
        { "@type": "Offer", "name": "12 Mois", "price": "60", "priceCurrency": "EUR", "availability": "https://schema.org/InStock", "priceValidUntil": "2026-12-31", "url": "https://roidustreaming.fr/iptv-pas-cher",
          "hasMerchantReturnPolicy": { "@type": "MerchantReturnPolicy", "applicableCountry": "FR", "returnPolicyCategory": "https://schema.org/MerchantReturnFiniteReturnWindow", "merchantReturnDays": 14, "returnMethod": "https://schema.org/ReturnByMail", "returnFees": "https://schema.org/FreeReturn" },
          "shippingDetails": { "@type": "OfferShippingDetails", "shippingRate": { "@type": "MonetaryAmount", "value": "0", "currency": "EUR" }, "shippingDestination": { "@type": "DefinedRegion", "addressCountry": "FR" }, "deliveryTime": { "@type": "ShippingDeliveryTime", "handlingTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 0, "unitCode": "h" }, "transitTime": { "@type": "QuantitativeValue", "minValue": 0, "maxValue": 1, "unitCode": "h" } } }
        }
      ]
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.8",
      "reviewCount": "2847"
    }
  };

  const faqJsonLd = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": faqData.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": { "@type": "Answer", "text": faq.answer }
    }))
  };

  const breadcrumbJsonLd = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      { "@type": "ListItem", "position": 1, "name": "Accueil", "item": "https://roidustreaming.fr" },
      { "@type": "ListItem", "position": 2, "name": "IPTV Pas Cher", "item": "https://roidustreaming.fr/iptv-pas-cher" }
    ]
  };

  return (
    <div className="min-h-screen bg-background">
      <Helmet>
        <title>IPTV Pas Cher 2025 - Dès 5€/mois | Économisez 90% vs Netflix+Canal</title>
        <meta name="description" content="IPTV pas cher dès 5€/mois ! Accédez à +15 000 chaînes, +100 000 films, +25 000 séries et sport 4K. Économisez jusqu'à 90% vs Netflix, Canal+, Disney+. Test gratuit 24h." />
        <meta name="keywords" content="iptv pas cher, iptv moins cher, iptv economique, iptv prix, iptv discount, iptv promo, streaming pas cher" />
        <link rel="canonical" href="https://roidustreaming.fr/iptv-pas-cher" />
        <meta property="og:title" content="IPTV Pas Cher 2025 - Dès 5€/mois | Économisez 90%" />
        <meta property="og:description" content="IPTV pas cher avec +15 000 chaînes, films, séries et sport 4K. Test gratuit 24h." />
        <meta property="og:url" content="https://roidustreaming.fr/iptv-pas-cher" />
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(faqJsonLd)}</script>
        <script type="application/ld+json">{JSON.stringify(breadcrumbJsonLd)}</script>
      </Helmet>

      <Header />
      <Breadcrumbs />

      {/* Hero Section */}
      <section className="pt-24 pb-16 px-4 bg-gradient-to-b from-secondary/10 to-background">
        <div className="max-w-6xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 bg-secondary/20 text-secondary px-4 py-2 rounded-full text-sm font-medium mb-6">
            <BadgePercent className="w-4 h-4" />
            <span>Économisez jusqu'à 90% sur votre streaming</span>
          </div>
          
          <h1 className="text-4xl md:text-6xl font-bold mb-6">
            <span className="gradient-text">IPTV Pas Cher</span> - Le Streaming
            <br />Premium dès <span className="text-secondary">5€/mois</span>
          </h1>
          
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto mb-8">
            Pourquoi payer <strong className="text-destructive">70€/mois</strong> pour Netflix, Canal+ et beIN Sports quand vous pouvez avoir 
            <strong className="text-secondary"> tout inclus pour 5€/mois</strong> ? Découvrez l'IPTV pas cher qui ne sacrifie pas la qualité.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Link to="/nos-offres">
              <Button size="lg" className="text-lg px-8 py-6 bg-secondary hover:bg-secondary/90 text-secondary-foreground">
                <Wallet className="w-5 h-5 mr-2" />
                Voir les Prix
              </Button>
            </Link>
            <Link to="/#pricing">
              <Button size="lg" variant="outline" className="text-lg px-8 py-6 border-primary/50 hover:bg-primary/10">
                <Play className="w-5 h-5 mr-2" />
                Tester Gratuitement
              </Button>
            </Link>
          </div>

          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground">
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-secondary" />
              <span>Dès 5€/mois</span>
            </div>
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-secondary" />
              <span>90% d'économie</span>
            </div>
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-secondary" />
              <span>Qualité 4K incluse</span>
            </div>
            <div className="flex items-center gap-2">
              <Check className="w-5 h-5 text-secondary" />
              <span>Sans engagement</span>
            </div>
          </div>
        </div>
      </section>

      {/* Comparatif Prix */}
      <section className="py-16 px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Comparez les prix : <span className="gradient-text">IPTV vs Streaming classique</span>
          </h2>
          <p className="text-center text-muted-foreground mb-12">
            Voyez combien vous économisez chaque mois avec l'IPTV pas cher
          </p>

          <div className="card-premium p-8 rounded-2xl">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="border-b border-border">
                    <th className="text-left py-4 px-4">Services</th>
                    <th className="text-center py-4 px-4">Prix mensuel</th>
                    <th className="text-center py-4 px-4">Prix annuel</th>
                    <th className="text-center py-4 px-4">Contenu</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-border/50">
                    <td className="py-4 px-4">Netflix Premium</td>
                    <td className="text-center py-4 px-4 text-destructive">19,99€</td>
                    <td className="text-center py-4 px-4 text-destructive">240€</td>
                    <td className="text-center py-4 px-4">Films/Séries</td>
                  </tr>
                  <tr className="border-b border-border/50">
                    <td className="py-4 px-4">Canal+ Sport</td>
                    <td className="text-center py-4 px-4 text-destructive">35€</td>
                    <td className="text-center py-4 px-4 text-destructive">420€</td>
                    <td className="text-center py-4 px-4">Sport + Séries</td>
                  </tr>
                  <tr className="border-b border-border/50">
                    <td className="py-4 px-4">beIN Sports</td>
                    <td className="text-center py-4 px-4 text-destructive">15€</td>
                    <td className="text-center py-4 px-4 text-destructive">180€</td>
                    <td className="text-center py-4 px-4">Football</td>
                  </tr>
                  <tr className="border-b border-border/50 bg-destructive/10">
                    <td className="py-4 px-4 font-bold">TOTAL Classique</td>
                    <td className="text-center py-4 px-4 text-destructive font-bold">~70€/mois</td>
                    <td className="text-center py-4 px-4 text-destructive font-bold">~840€/an</td>
                    <td className="text-center py-4 px-4">Partiel</td>
                  </tr>
                  <tr className="bg-secondary/10">
                    <td className="py-4 px-4 font-bold flex items-center gap-2">
                      <Sparkles className="w-5 h-5 text-secondary" />
                      RoiDuStreaming
                    </td>
                    <td className="text-center py-4 px-4 text-secondary font-bold text-xl">5€/mois</td>
                    <td className="text-center py-4 px-4 text-secondary font-bold text-xl">60€/an</td>
                    <td className="text-center py-4 px-4 font-bold text-secondary">TOUT INCLUS</td>
                  </tr>
                </tbody>
              </table>
            </div>
            
            <div className="mt-8 p-6 bg-secondary/20 rounded-xl text-center">
              <div className="flex items-center justify-center gap-2 mb-2">
                <TrendingDown className="w-6 h-6 text-secondary" />
                <span className="text-2xl font-bold text-secondary">Économie : 780€/an</span>
              </div>
              <p className="text-muted-foreground">Soit 93% d'économie par rapport aux abonnements classiques</p>
            </div>
          </div>
        </div>
      </section>

      {/* Ce que vous obtenez */}
      <section className="py-16 px-4 bg-card">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Ce que vous obtenez avec notre <span className="gradient-text">IPTV pas cher</span>
          </h2>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="bg-background card-premium p-6 rounded-2xl text-center">
              <div className="text-4xl font-bold text-primary mb-2">15 000+</div>
              <h3 className="font-bold mb-2">Chaînes TV</h3>
              <p className="text-sm text-muted-foreground">France, Europe, monde entier</p>
            </div>
            <div className="bg-background card-premium p-6 rounded-2xl text-center">
              <div className="text-4xl font-bold text-primary mb-2">100 000+</div>
              <h3 className="font-bold mb-2">Films</h3>
              <p className="text-sm text-muted-foreground">Nouveautés chaque semaine</p>
            </div>
            <div className="bg-background card-premium p-6 rounded-2xl text-center">
              <div className="text-4xl font-bold text-primary mb-2">25 000+</div>
              <h3 className="font-bold mb-2">Séries</h3>
              <p className="text-sm text-muted-foreground">VF et VOSTFR disponibles</p>
            </div>
            <div className="bg-background card-premium p-6 rounded-2xl text-center">
              <div className="text-4xl font-bold text-primary mb-2">4K HDR</div>
              <h3 className="font-bold mb-2">Qualité Maximale</h3>
              <p className="text-sm text-muted-foreground">Sans surcoût</p>
            </div>
          </div>
        </div>
      </section>

      {/* Nos Tarifs */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-4">
            Nos tarifs <span className="gradient-text">IPTV pas cher</span>
          </h2>
          <p className="text-center text-muted-foreground mb-12">
            Plus vous prenez longtemps, plus vous économisez
          </p>

          <div className="space-y-4">
            <div className="card-premium p-6 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-4">
              <div className="text-center md:text-left">
                <h3 className="text-xl font-bold text-primary">3 MOIS</h3>
                <p className="text-muted-foreground">90 jours d'accès</p>
              </div>
              <div className="text-center">
                <span className="text-3xl font-bold">25€</span>
                <p className="text-sm text-muted-foreground">8,33€/mois</p>
              </div>
              <Link to="/nos-offres">
                <Button className="btn-primary text-primary-foreground">
                  Choisir <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>

            <div className="card-premium p-6 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-4 border-2 border-primary glow-primary">
              <div className="text-center md:text-left">
                <div className="flex items-center gap-2 justify-center md:justify-start">
                  <h3 className="text-xl font-bold text-primary">6 MOIS</h3>
                  <span className="bg-gold text-gold-foreground text-xs px-2 py-1 rounded-full font-bold">POPULAIRE</span>
                </div>
                <p className="text-muted-foreground">180 jours d'accès</p>
              </div>
              <div className="text-center">
                <span className="text-3xl font-bold text-primary">40€</span>
                <p className="text-sm text-secondary font-medium">6,67€/mois</p>
              </div>
              <Link to="/nos-offres">
                <Button className="bg-primary hover:bg-primary/90 text-primary-foreground">
                  Choisir <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>

            <div className="card-premium p-6 rounded-2xl flex flex-col md:flex-row items-center justify-between gap-4 border-2 border-secondary">
              <div className="text-center md:text-left">
                <div className="flex items-center gap-2 justify-center md:justify-start">
                  <h3 className="text-xl font-bold text-primary">12 MOIS</h3>
                  <span className="bg-secondary text-secondary-foreground text-xs px-2 py-1 rounded-full font-bold">MEILLEUR PRIX</span>
                </div>
                <p className="text-muted-foreground">365 jours d'accès</p>
              </div>
              <div className="text-center">
                <span className="text-3xl font-bold text-secondary">60€</span>
                <p className="text-sm text-secondary font-medium">5€/mois - Économisez 40%</p>
              </div>
              <Link to="/nos-offres">
                <Button className="bg-secondary hover:bg-secondary/90 text-secondary-foreground">
                  Choisir <ArrowRight className="w-4 h-4 ml-2" />
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Témoignages */}
      <section className="py-16 px-4 bg-card">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Ce que disent nos clients sur l'<span className="gradient-text">IPTV pas cher</span>
          </h2>

          <div className="grid md:grid-cols-3 gap-6">
            <div className="bg-background card-premium p-6 rounded-2xl">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-gold text-gold" />
                ))}
              </div>
              <p className="text-muted-foreground mb-4">"Je payais 65€/mois pour Netflix, Canal et beIN. Maintenant je paie 5€/mois pour plus de contenu. Incroyable !"</p>
              <p className="font-bold">- Marc L.</p>
            </div>
            <div className="bg-background card-premium p-6 rounded-2xl">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-gold text-gold" />
                ))}
              </div>
              <p className="text-muted-foreground mb-4">"Sceptique au début vu le prix, mais la qualité est au rendez-vous. Même le sport en 4K fonctionne parfaitement."</p>
              <p className="font-bold">- Sophie D.</p>
            </div>
            <div className="bg-background card-premium p-6 rounded-2xl">
              <div className="flex items-center gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-gold text-gold" />
                ))}
              </div>
              <p className="text-muted-foreground mb-4">"L'IPTV pas cher qui tient ses promesses ! Toute la famille est ravie, on a tout ce qu'il nous faut."</p>
              <p className="font-bold">- Thomas R.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section className="py-16 px-4">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-center mb-12">
            Questions sur l'<span className="gradient-text">IPTV Pas Cher</span>
          </h2>

          <Accordion type="single" collapsible className="space-y-4">
            {faqData.map((faq, index) => (
              <AccordionItem
                key={index}
                value={`item-${index}`}
                className="card-premium border-none rounded-xl overflow-hidden"
              >
                <AccordionTrigger className="px-6 py-4 hover:no-underline text-left font-semibold hover:bg-primary/5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="px-6 pb-4 text-muted-foreground">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </section>

      {/* CTA Final */}
      <section className="py-16 px-4 bg-gradient-to-b from-secondary/10 to-background">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Prêt à économiser avec l'<span className="gradient-text">IPTV pas cher</span> ?
          </h2>
          <p className="text-xl text-muted-foreground mb-8">
            Arrêtez de payer trop cher. Rejoignez les milliers de clients qui économisent chaque mois.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/nos-offres">
              <Button size="lg" className="text-lg px-8 py-6 bg-secondary hover:bg-secondary/90 text-secondary-foreground">
                <Wallet className="w-5 h-5 mr-2" />
                Voir les Prix
              </Button>
            </Link>
            <Link to="/#pricing">
              <Button size="lg" variant="outline" className="text-lg px-8 py-6 border-primary/50 hover:bg-primary/10">
                Test Gratuit 24h
              </Button>
            </Link>
          </div>

          {/* Liens internes SEO */}
          <div className="mt-12 pt-8 border-t border-border">
            <p className="text-sm text-muted-foreground mb-4">Découvrez aussi :</p>
            <div className="flex flex-wrap justify-center gap-4 text-sm">
              <Link to="/iptv-france" className="text-primary hover:underline">IPTV France</Link>
              <Link to="/abonnement-iptv" className="text-primary hover:underline">Abonnement IPTV</Link>
              <Link to="/nos-offres" className="text-primary hover:underline">Toutes nos Offres</Link>
              <Link to="/avis-clients" className="text-primary hover:underline">Avis Clients</Link>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default IptvPasCher;
